// extracted by mini-css-extract-plugin
export default {"root":"TextArea_root__nBvxD"};